<template src="./CredentialsModal.html">
</template>
<script>
import axios from 'axios'
import loading from '@/components/PageLoader'

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  name: "credentials-modal",
  components: {
    loading
  },
  props: {
    error: {
      type: Error | Object | null | undefined,
    },
    parentCallback: { type: Function }
  },
  data() {
    return {
        isLoading: false,
        password: "",
        isSubmitting: false,
        submitError: null,
        sessionExpired: false
    }
  },
  computed: {
    errorTitle() {
      return this.error && this.error.response && this.error.response.data && this.error.response.data.title
        || this.$t("BPSessionExpired");
    },

    errorDetail() {
      return this.error && this.error.response && this.error.response.data && this.error.response.data.detail
        || this.$t("EnterBPCredentials");
    },
    shouldReload() {
      return this.error && this.error.config.method === 'get' || this.sessionExpired;
    }
  },
    methods: {
      show() {
        this.sessionExpired = true;
        this.$nextTick(() => this.$refs['credentials-modal'].show());
      },
    checkForSession() {
      if (!this.$auth.isAuthenticated()) return;
      axios.get(`/users/current/session/is-active?nocache=true&timestamp=${new Date().getTime()}`)
        .then(response => {
          const {
            data,
            status
          } = response;
           if (status === 200 && !data) {
            this.sessionExpired = true;
            this.$refs['credentials-modal'].show();
          } else {
          // TODO better error handling
            if (this.parentCallback)
              this.parentCallback(false);
          }
        })
        .catch(error => console.log(`
          An error occurred when confirming if you're logged in:
          ${error}
        `));
    },
    handleOk(modalEvent) {
      modalEvent.preventDefault();
      if (this.password)
        this.submitCredentials();
    },
    handleSubmit() {
      if (this.password)
        this.submitCredentials();
    },
    submitCredentials() {
      const credentialsEndpoint = `/users/current/session`;

      let app = this;

      this.isLoading = true;
      this.isSubmitting = true;

      axios.post(credentialsEndpoint, { password: this.password })
        .then(response => {

          app.isLoading = false;

          this.isSubmitting = false;
          if (response.status === 200) {
            this.password = "";
            this.submitError = null;

            if (this.parentCallback) {
              this.sessionExpired = false;
              this.$nextTick(() => {
                this.$refs['credentials-modal'].hide();
                this.parentCallback(true);
              });
              return;
            }

            this.$nextTick(() => {
              this.$refs['credentials-modal'].hide();
              if (this.shouldReload) {
                this.sessionExpired = false;
                this.$router.go();
              };
            })
          }
          // TODO better error handling
        })
        .catch(error => {
          app.isLoading = false;
          this.isSubmitting = false;
          this.submitError = error;
          console.log(`An error occurred when submitting your password:
            ${error}`)
        })
    }
  },
  mounted() {
    // this component is at the App root so this check happens exactly once per page load;
    // manually reloading the page runs this check again but navigation and closing/reopening the modal does not
    //this.checkForSession();
  },
}
</script>
